import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getInformeMes } from '../../../domain/api/EvbiApi';
import { USER_ID } from '../../../../app/api-client/constants';

export function useDashboardData() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const [stats, setStats] = useState({
    estacionesActivas: null,
    estacionesOffline: null,
    registrosPendientes: null,
    medicionesMes: null,
    estacionesInactivas: null,
  });

  const [estaciones, setEstaciones] = useState([]);
  const [donutData, setDonutData] = useState({ series: [], labels: [] });
  const [barData, setBarData] = useState({ categorias: [], serieActual: [], serieAnterior: [] });
  const fetchData = useCallback(async () => {
    const userId = localStorage.getItem(USER_ID);

    if (!userId) {
      setError('Usuario no autenticado');
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);

      const response = await getInformeMes(dispatch, userId);
      if (!response || response.error) {
        setError(response?.error || 'Error al obtener datos del informe');
        return;
      }

      const estaciones = Array.isArray(response) ? response :
        Object.keys(response)
          .filter(key => !isNaN(Number(key)))
          .sort((a, b) => Number(a) - Number(b))
          .map(key => response[key]);



      setEstaciones(estaciones);

      const activas = estaciones.filter(est => est.estado === 'ACTIVO').length;
      const inactivas = estaciones.filter(est => est.estado !== 'ACTIVO').length;
      const pendientesTotal = estaciones.reduce((acc, est) => acc + (est.registros_pendientes || 0), 0);
      const mediciones = estaciones.reduce((acc, est) => acc + (est.mediciones_mes_actual || 0), 0);
      const hoy = new Date().toISOString().slice(0, 10);
      const offline = estaciones.filter(est => !est.ultima_Conexion || !est.ultima_Conexion.startsWith(hoy)).length;

      setStats({
        estacionesActivas: activas,
        estacionesInactivas: inactivas,
        registrosPendientes: pendientesTotal,
        medicionesMes: mediciones,
        estacionesOffline: offline,
      });

      const conPendientes = estaciones.filter(e => e.registros_pendientes > 0);
      setDonutData({
        labels: conPendientes.map(e => e.name),
        series: conPendientes.map(e => e.registros_pendientes),
      });

      setBarData({
        categorias: estaciones.map(e => e.name),
        serieActual: estaciones.map(e => e.mediciones_mes_actual || 0),
        serieAnterior: estaciones.map(e => e.mediciones_mes_anterior || 0),
      });

    }
    catch (err) {
      console.error('Error al cargar datos del dashboard:', err);
      setError('Error al cargar datos del dashboard');
    } finally {
      setLoading(false);
    }

  }, [dispatch]);


  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { loading, stats, estaciones, donutData, barData, refetch: fetchData };
}
